module.exports = __webpack_public_path__ + "img/lock.be2890f1.svg";